import { useState } from "react";
import { CaretDownIcon } from "@phosphor-icons/react";

export default function FAQItem({ q, a, idx }) {
    const [open, setOpen] = useState(false);
    return (
        <div
            className="border border-white/10 rounded-3xl bg-surface overflow-hidden transition-colors hover:border-white/20"
            data-testid={`faq-${idx}`}
        >
            <button
                onClick={() => setOpen((o) => !o)}
                className="w-full px-6 py-5 flex items-start justify-between gap-6 text-left"
                data-testid={`faq-toggle-${idx}`}
            >
                <span className="font-heading font-bold text-base md:text-lg flex-1">{q}</span>
                <CaretDownIcon
                    size={22}
                    weight="bold"
                    color="#FFA700"
                    className={`shrink-0 mt-1 transition-transform duration-300 ${
                        open ? "rotate-180" : ""
                    }`}
                />
            </button>
            {open && (
                <div className="px-6 pb-5 -mt-1 text-text-secondary leading-relaxed text-sm md:text-base fade-up">
                    {a}
                </div>
            )}
        </div>
    );
}
